import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";
import type { WorkspaceAccount } from "common/types";

import AccountActionsDropdown from "../AccountActionsDropdown";
import AccountName from "../AccountName";

interface HeaderProps {
  account: WorkspaceAccount;
  isDesktop: boolean;
  pictureUrl: string | undefined;
  occupation?: string;
}

export default function Header({
  account,
  isDesktop,
  pictureUrl,
  occupation,
}: HeaderProps) {
  return (
    <div className="flex max-lg:pl-16 px-4 py-3 lg:py-4 border-b border-b-black-200 gap-x-2 lg:gap-x-2.5 items-start">
      <div className="flex gap-x-3 items-start flex-1">
        <ProfileImage src={pictureUrl} size={isDesktop ? "lg" : "md"} />

        <div className="flex flex-col gap-y-1">
          <AccountName
            account={account}
            className="text-sm-bold lg:text-lg-bold"
          />

          <p className="text-black-500 text-xs-medium lg:text-sm-medium">
            {occupation}
          </p>
        </div>
      </div>

      <RenderIf condition={!isDesktop}>
        <RenderIf condition={account.type === "user"}>
          <AccountActionsDropdown account={account} />
        </RenderIf>
      </RenderIf>
    </div>
  );
}
